import {
  LCLSTRG_AUCTIONID_SUFFIX,
  LCLSTRG_LANEID_SUFFIX,
} from 'shared/constants';

export const getRouteFromPathName = () =>
  window.location.pathname.split('/')[1];

export const setStoredValue = (key, value) =>
  window.localStorage.setItem(key, value);

export const getStoredValue = (key) => window.localStorage.getItem(key);

export const removeStoredValue = (key) => window.localStorage.removeItem(key);

export const clearLocalStorageItems = () => {
  const keys = Object.keys(localStorage);
  for (let key of keys) {
    if (!key.startsWith('cache')) {
      localStorage.removeItem(key);
    }
  }
};

export const clearStorage = (clearSimLog = false) => {
  if (clearSimLog) {
    clearLocalStorageItems();
    return;
  }

  const keys = Object.keys(localStorage);
  for (let key of keys) {
    if (key !== 'simulcast_log' && key !== 'cacheVersion') {
      localStorage.removeItem(key);
    }
  }
};

export const getStoredAuctionLaneIdByPath = () =>
  getStoredValue(
    `${getRouteFromPathName().toLowerCase()}${LCLSTRG_LANEID_SUFFIX}`,
  );

export const setStoredAuctionLaneIdByPath = (value, path = null) =>
  setStoredValue(
    `${
      path?.toLowerCase() ?? getRouteFromPathName().toLowerCase()
    }${LCLSTRG_LANEID_SUFFIX}`,
    value,
  );

export const removeStoredAuctionLaneIdByPath = () =>
  removeStoredValue(
    `${getRouteFromPathName().toLowerCase()}${LCLSTRG_LANEID_SUFFIX}`,
  );

export const getStoredAuctionIdByPath = () =>
  getStoredValue(
    `${getRouteFromPathName().toLowerCase()}${LCLSTRG_AUCTIONID_SUFFIX}`,
  );

export const setStoredAuctionIdByPath = (value, path = null) => {
  setStoredValue(
    `${
      path?.toLowerCase() ?? getRouteFromPathName().toLowerCase()
    }${LCLSTRG_AUCTIONID_SUFFIX}`,
    value,
  );
};

export const removeStoredAuctionIdByPath = () =>
  removeStoredValue(
    `${getRouteFromPathName().toLowerCase()}${LCLSTRG_AUCTIONID_SUFFIX}`,
  );

export const setCookie = (key, value) => {
  const domain =
    window.location.href.indexOf('localhost') > -1
      ? 'localhost'
      : 'npauctions.com';
  document.cookie = `${key}=${JSON.stringify(value).replace(
    /[\u0080-\uFFFF]+/g,
    '',
  )}; domain=${domain}`;
};
